let handler: (e: unknown) => void = () => {};

export function setResourceGridFetchErrorHandler(fn: (e: unknown) => void): void {
	handler = fn;
}

export function reportResourceGridFetchError(e: unknown): void {
	handler(e);
}
